module.exports = __webpack_public_path__ + "img/MESTNA OBCINA SLOVENJ GRADEC.b011cd65.png";